import React, { useState, useContext } from "react";
import { AlertCard } from "@texada/ui";
import { isPlayEnv } from "helpers/helper";
import LoginContext from "./LoginContext";
import { SERVICE_UNAVAILABLE } from "http-status-codes";

const LoginInfoDisplay: React.FC<{
  errorMsg: React.ReactNode;
}> = props => {
  const { error } = useContext(LoginContext);
  const displayAdditionalMsg = () => {
    if (isPlayEnv() && error?.response.status === SERVICE_UNAVAILABLE) {
      return (
        <>
          <br />
          <div className="api-error">
            Please try logging in again later. This may take some time,
            depending on the size of your data.
          </div>
        </>
      );
    }
  };

  return (
    <AlertCard type="error" size="full" closable={false}>
      <div>{props.errorMsg}</div>
      {displayAdditionalMsg()}
    </AlertCard>
  );
};

export default LoginInfoDisplay;
